// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.UserRolePermission.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import Input from 'share/components/controls/Izenda.Input';
import SearchTextBox from 'share/components/controls/Izenda.SearchTextBox';
import TextHighLight from 'share/components/controls/Izenda.TextHighLight';
import LazyLoadingTreeView from 'share/components/controls/LazyLoadingTreeView/Izenda.LazyLoadingTreeView';
import { compose, mapProps } from 'recompose';
import { invoke } from 'lodash/fp';
const CommonTreeSearch = compose(
  mapProps(props => ({
    debounceOnChange: true,
    value: props.rolePermission.filterText,
    onChange(e) {
      props.rolePermission.filterText = e.target.value;
      props.searchRoles(props.rolePermission.filterText);
    }
  }))
)(SearchTextBox);

@connect()
export default class UserRolePermission extends Component {
  renderNode = (node: any, toggleIcon: any, toggle: any, isCollapsed: boolean, parent: any) => {
    const { source, disabled, showTotal } = node;
    const onChangeFunc = this.handleChange.bind(this, node, parent);
    const { filterText } = this.props.rolePermission;

    return (
      <div className='checkbox u_noMarginAll'>
        <label>
          <Input
            type='checkbox'
            indeterminate={source.indeterminate}
            checked={disabled ? false : source.checked}
            onChange={onChangeFunc}
            disabled={disabled}
          />
          <TextHighLight text={source.name} highlight={filterText} className='u_textNormal' />
          {showTotal && <span className='selectable u_inline'>({source.numOfChilds})</span>}
        </label>
        {toggleIcon}
      </div>
    );
  };

  handleChange(node: any, parent: any, evt: any) {
    node.onChange(node.source, parent, evt);
    this.props.updateSelectedNode(node, parent, this.props.accessModel);
  }

  getKey = (node: any): string => {
    return node.source.id + '_' + node.source.parentId;
  };

  render() {
    const { rolePermission, getData, searchRoles, localization } = this.props;
    const { lazyLoadingStore, isLastPage, displayData } = rolePermission;

    return (
      <div className='izenda-UserRolePermision izenda-CommonTree u_table u_fullSize u_borderAll'>
        <div className='u_tableRow'>
          <div className='u_tableCell u_paddingAll u_borderBottom'>
            <span className='icon-menu u_marginRight' />
            <span className='u_textBold'>
              {localization.getText('TENANT_CONSTANT_TENANT_PERMISSIONS_SHARE_WITH_TREE_HEADER')}
            </span>
          </div>
        </div>

        <div className='u_tableRow'>
          <div className='u_tableCell u_paddingAll u_borderBottom'>
            <div className='u-posRelative'>
              <CommonTreeSearch rolePermission={rolePermission} searchRoles={searchRoles} />
            </div>
          </div>
        </div>

        <div className='u_tableRow'>
          <div className='u_tableCell u_fullSize'>
            <LazyLoadingTreeView
              nodes={displayData}
              getKey={this.getKey}
              renderNode={this.renderNode}
              getChildNodes={invoke('getChildNodes')}
              isLastPage={isLastPage}
              getData={getData}
              viewHeight={lazyLoadingStore.viewHeight}
              itemHeight={lazyLoadingStore.itemHeight}
              registerLazyLoadingStore={rolePermission.registerLazyLoadingStore.bind(rolePermission)}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/PermissionTab/PermissionBody/Izenda.UserRolePermission.jsx